export async function acquireCameraStream(
  video: HTMLVideoElement | null,
  mediaDevices: Pick<MediaDevices, "getUserMedia"> = navigator.mediaDevices,
): Promise<MediaStream> {
  let stream: MediaStream;
  try {
    stream = await mediaDevices.getUserMedia({
      audio: false,
      video: { facingMode: { ideal: "environment" }, width: { ideal: 1280 }, height: { ideal: 720 } },
    });
  } catch (cause) {
    // Some mobile browsers reject the ideal constraints instead of relaxing them.
    // Retry with the browser's default camera before reporting a real failure.
    if (!(cause instanceof DOMException) || !["OverconstrainedError", "NotFoundError"].includes(cause.name)) throw cause;
    stream = await mediaDevices.getUserMedia({ audio: false, video: true });
  }

  if (!video) {
    releaseCameraStream(stream, null);
    throw new Error("The camera preview is not available.");
  }

  video.autoplay = true;
  video.muted = true;
  video.playsInline = true;
  video.srcObject = stream;
  try {
    await video.play();
    return stream;
  } catch (cause) {
    releaseCameraStream(stream, video);
    throw cause;
  }
}

export function releaseCameraStream(stream: MediaStream | null, video: HTMLVideoElement | null): void {
  stream?.getTracks().forEach((track) => track.stop());
  if (video) video.srcObject = null;
}

/** The visitor actively refused, as opposed to the camera being unusable. */
export function isPermissionDenied(cause: unknown): boolean {
  return cause instanceof DOMException
    && (cause.name === "NotAllowedError" || cause.name === "SecurityError");
}
